export default {
	/**
	 * init post list-entry screenreader labels
	 */
	init() {
		[...this.$el.getElementsByClassName('post--list-entry')].forEach(post => {
			[...post.querySelectorAll('.post__wrapper, .post__container')].forEach(wrapper =>
				wrapper.setAttribute('aria-hidden', true)
			);
			const headline = post.querySelector('.post__wrapper--text > .element--headline');
			const text = post.querySelector('.post__wrapper--text > .element--text');
			post.setAttribute(
				'aria-label',
				`${headline ? headline.textContent : ''}\n${text ? text.textContent : ''}`
			);
			post.setAttribute('role', 'link');
		});
	},
	destroy() {},
};
